import { render, staticRenderFns } from "./addGame.vue?vue&type=template&id=cf396e4c&"
import script from "./addGame.vue?vue&type=script&lang=js&"
export * from "./addGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf396e4c')) {
      api.createRecord('cf396e4c', component.options)
    } else {
      api.reload('cf396e4c', component.options)
    }
    module.hot.accept("./addGame.vue?vue&type=template&id=cf396e4c&", function () {
      api.rerender('cf396e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addGame.vue"
export default component.exports